"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var Banner_1 = __importDefault(require("./Banner"));
var Provider_1 = __importDefault(require("./Provider"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Providers = function (_a) {
    var _b;
    var providers = _a.providers;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var isMobile = breakpoints.mobile && ((_b = Object.keys(breakpoints)) === null || _b === void 0 ? void 0 : _b.length) > 0;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _c = (0, react_1.useState)(function () {
        return isMobile ? 6 : 12;
    }), visibleProviders = _c[0], setVisibleProviders = _c[1];
    var providersToShow = providers.slice(0, visibleProviders);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Banner_1.default, null),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, providersToShow.map(function (item, idx) { return (react_1.default.createElement(Provider_1.default, __assign({ key: "".concat(item.title) }, item))); })),
            react_1.default.createElement("button", { onClick: function () {
                    return setVisibleProviders(function (prev) { return (isMobile ? prev + 6 : prev + 12); });
                }, className: styles_module_scss_1.default.button, style: { whiteSpace: 'nowrap' } }, t('loadMore')))));
};
exports.default = Providers;
